// 작은 수학 도구들. 프로토타입 값과 시드를 그대로 유지한다.

/** 정수 시드로 만드는 0~1 사이 고정 난수. 장면 배치가 매번 같게 나오도록 프로토타입 공식을 그대로 쓴다. */
export const rnd = (i: number): number => {
  const x = Math.sin(i * 127.1) * 43758.5453;
  return x - Math.floor(x);
};

/** a~b 사이 무작위 값 (매번 다름). */
export const rand = (a: number, b: number): number => a + Math.random() * (b - a);

/** 두 각도의 차이를 -π~π로. */
export const angDiff = (a: number, b: number): number => Math.atan2(Math.sin(a - b), Math.cos(a - b));

export const clamp = (v: number, a: number, b: number): number => Math.max(a, Math.min(b, v));

/** 바닥 평면(x, z) 위 거리. */
export const distXZ = (p: { x: number; z: number }, q: { x: number; z: number }): number =>
  Math.hypot(p.x - q.x, p.z - q.z);

export function easeOutBounce(x: number): number {
  const n1 = 7.5625, d1 = 2.75;
  if (x < 1 / d1) return n1 * x * x;
  if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
  if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
  return n1 * (x -= 2.625 / d1) * x + 0.984375;
}
